import styled from 'styled-components';
import Note from '@gcc/countertops-components/dist/OptionGroupNote/styles'; // need to port
import { Slider } from '@gcc/pip-components/dist/Carousel/styles';
import assetsPath from '../../../../utils/assetsPath';

export default {
  dimensionsOuterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  border: {
    color: '#444',
    display: 'block',
    borderBottom: '1px solid #ccc',
    paddingTop: '20px',
    paddingBottom: '5px',
    position: 'relative',
  },
};

export const NoteWrapper = styled.span`
  ${Note} {
    font-size: 1.8rem;
  }
    span {
    font-size: 1.8rem;}
`;

export const Mobile = styled.div`
  display: none;
  @media(max-width: 1024px) {
    display: block;
  }
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Root = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const AccSectionHeader = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ChevronWrapper = styled.div`
  margin: 11px 10px 10px 0px;
  @media(max-width: 1024px) {
    margin: 7px 10px 10px 0px !important;
  }
`;

export const ChevronSign = styled.div`
  background-image: url(${assetsPath}/icons/MinusSign.svg);
  background-repeat: no-repeat;
  height: 17px;
  width: 17px;
  -moz-transition: all 0.1s linear;
  -webkit-transition: all 0.1s linear;
  transition: all 0.1s linear;
  ${Root}.isCollapsed && {
    background-image: url(${assetsPath}/icons/PlusSign.svg);
  }
`;

export const AccSectionBody = styled.div`
  height: auto;
  width: 100%;
  overflow: hidden;
  ${Root}.isCollapsed & {
    height: 0;
    padding: 0;
  }
`;

export const CarouselWrapper = styled.div`
  margin-top: 8px;
  width: 100%;
  .option-card, .active-card {
    min-height: 255px;
  }
`;

export const FlexStretchDiv = styled.div`
  ${Slider} {
    align-items: stretch;
    margin-bottom: 0px;
    @media and (max-width: 1024px) {
      overflow: auto hidden;
    }
  }
`;
